"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Pricing = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _cloneDeep = _interopRequireDefault(require("lodash/cloneDeep"));

var _TransformRuleSetBase = require("./TransformRuleSetBase");

var Pricing =
/*#__PURE__*/
function () {
  function Pricing() {
    (0, _classCallCheck2["default"])(this, Pricing);
  }

  (0, _createClass2["default"])(Pricing, null, [{
    key: "updateRuleSet",
    value: function updateRuleSet(ruleSet, requiredAttributes) {
      var clonedRuleSet = (0, _cloneDeep["default"])(ruleSet);

      var attributesWhiteList = _TransformRuleSetBase.TransformRuleSetBase.convertAttributesInWhiteList(requiredAttributes);

      if (ruleSet && ruleSet.whiteList) {
        clonedRuleSet.whiteList = Pricing.union(attributesWhiteList, clonedRuleSet.whiteList);
      }

      return clonedRuleSet;
    }
  }, {
    key: "union",
    value: function union(requiredAttributes, whiteList) {
      var dict = {};
      whiteList.forEach(function (attribute) {
        dict["".concat(attribute["class"].toLowerCase(), "##").concat(attribute.attributeKey.toLowerCase())] = attribute;
      });
      requiredAttributes.forEach(function (attribute) {
        dict["".concat(attribute["class"].toLowerCase(), "##").concat(attribute.attributeKey.toLowerCase())] = attribute;
      });
      return Object.values(dict);
    }
  }]);
  return Pricing;
}();

exports.Pricing = Pricing;